import type { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import { tv } from "tailwind-variants";
import type { VariantProps } from "tailwind-variants";

const bannerVariants = tv({
  base: "col-span-2 w-full rounded-xl border p-4",
  variants: {
    variant: {
      error: "border-error-700 bg-error-50 text-error-950",
      warning: "border-warning-700 bg-warning-50 text-warning-950",
    },
  },
  defaultVariants: {
    variant: "error",
  },
});

export type BannerProps = ComponentPropsWithoutRef<"div"> &
  VariantProps<typeof bannerVariants> &
  PropsWithChildren;

export const Banner = ({ children, variant }: BannerProps) => {
  return <div className={bannerVariants({ variant })}>{children}</div>;
};
